export default [
  {
    title: `O que é o adiantamento do Saque Aniversário?`,
    text: `O adiantamento do Saque Aniversário é uma modalidade que permite que você tenha acesso a uma parcela do valor disponível na sua conta do FGTS de forma antecipada. É possível que você realize essa operação tendo a partir de R$300 desbloqueados. Os descontos acontecem de forma programada e anual diretamente da conta do benefício, tendo como regra de desconto o mínimo de 02 anos e máximo de 10. Com isso, o valor a receber varia proporcionalmente.`,
  },
  {
    title: 'Quais são as etapas de solicitação da antecipação?',
    text: `
      Para solicitar a antecipação do Saque Aniversário é necessário que alguns passos simples sejam realizados antes de chegar à consulta com nosso time. Os passos são:
      <br />
      <br />
      1- <a href="https://play.google.com/store/apps/details?id=br.gov.caixa.fgts.trabalhador&hl=pt_BR&gl=US&pli=1" target="_blank">Baixar o aplicativo FGTS;</a>
      <br />
      2- Acessar o aplicativo com seu usuário e senha;
      <br />
      3- Selecionar a opção “Saque Aniversário” na tela inicial;
      <br />
      4- Aceitar os termos e clicar em “optar pelo Saque Aniversário”.
      <br />
      <br />
      Feito esse processo, é necessário realizar a autorização do banco Votorantim para que o time da JB consiga gerar sua proposta. Para isso, siga os passos abaixo.
      <br />
      <br />
        1- No aplicativo do FGTS clicar em autorizar bancos a consultarem seu FGTS
        <br />
        2- Escolher a opção “Empréstimo Saque Aniversário”
        <br />
        3- Buscar por “Banco Votorantim”
        <br />
        4- Clicar em continuar para realizar a consulta
        <br />
        5- Selecionar o banco em questão e concluir.
        <br />
        <br />
        A partir desse momento, você está apto a conversar com nossos consultores e ter acesso a sua proposta de antecipação.
    `,
  },
  {
    title: 'Qual a documentação necessária para contratar?',
    text: `
      Para realizar a sua contratação de forma segura, é necessário que alguns documentos sejam fornecidos na hora de firmar o contrato. Não se preocupe, a JB tem autorização para realizar esse tipo de operação diretamente pelo Whatsapp. Os documentos solicitados são:
      <br />
      <br />
      - Foto do RG (frente e verso) ou CNH (aberta)
      <br />
      - Foto do CPF (caso não tenha na identidade)
      <br />
      - CEP e número da residência
      <br />
      - E-mail
      <br />
      - Celular
      <br />
      - Profissão
      <br />
      - Dados bancários em seu nome (Nome do banco, Agência, Conta, Corrente ou Poupança)
    `,
  },
  {
    title: `Posso quitar as parcelas da minha antecipação?`,
    text: `
    Claro! É possível que você adiante o pagamento do seu contrato. Porém, esta ação precisa ser feita com recursos próprios. Não é possível utilizar o saldo do FGTS para esta quitação adiantada. A solicitação é bem simples, basta entrar em contato com o SAC do BV. 
    <br />
    <br />
    SAC
    <br />
    0800 728 0083
    <br />
    sac@bv.com.br
    <br />
    Atendimento para Deficiente Auditivos e de Fala*: 0800 701 8661
    `,
  },
  {
    title: `Qual a taxa de juros do Saque Aniversário?`,
    text: `A taxa de juros para a realização da operação varia de acordo com o saldo desbloqueado disponível, valor determinado para cada parcela e o mês de aniversário. Com isso, cada simulação tem sua particularidade, variando a taxa de 1,49% à 2,05%.`,
  },
  {
    title: `Quais são os requisitos para pedir um empréstimo?`,
    text: `Esta modalidade exige que alguns requisitos sejam cumpridos, como:
    <ul>
      <li>Idade mínima de 18 anos;</li>
      <li>Não ser aposentado;</li>
      <li>Possuir um saldo igual ou superior a R$300 desbloqueados na conta do FGTS;</li>
      <li>Ser optante pelo Saque Aniversário do FGTS;</li>
      <li>Ter o CPF em regular junto à Receita Federal;</li>
      <li>Não possuir débitos referentes a antecipações anteriores.</li>
    </ul>
    `,
  },
  {
    title: `Quais bancos são aceitos para depósito?`,
    text: `O depósito do valor firmado em contrato pode ser feito em qualquer conta que seja da titularidade do solicitante. Salvo conta salário e PJ.`,
  },
  {
    title: `Quanto tempo demora para saber se fui aprovado?`,
    text: `O time de atendimento da Juros Baixos acompanhará todo o seu processo de contratação. O tempo de aprovação pode variar de acordo com as possibilidades do banco parceiro, uma vez que apenas intermediamos a realização da operação. Mas não se preocupe, acompanhamos do início ao fim a sua solicitação. O tempo médio é de 24 horas úteis.`,
  },
  {
    title: `Em quanto tempo vou receber o dinheiro na minha conta bancária?`,
    text: `O tempo de depósito após a aprovação documental é variável. Porém com prazo máximo de 24 horas úteis. Caso ultrapasse este limite, entre em contato conosco ou com o SAC do Banco Votorantim.
    <br /> 
    <br /> 
    SAC
    <br />
    0800 728 0083.
    <br />
    <br />
    Atendimento para Deficiente Auditivos e de Fala*: 0800 701 8661
    `,
  },
]
